import client from "./client";

export const adminApi = {
  getOverview: () => client.get("/api/admin/overview"),
  getAcquisition: () => client.get("/api/admin/acquisition"),
  getUsers: (params) => client.get("/api/admin/users", { params }),
  getUserDetail: (id) => client.get(`/api/admin/users/${id}`),
  updateUserRole: (id, role) => client.patch(`/api/admin/users/${id}/role?role=${role}`),
  deleteUser: (id) => client.delete(`/api/admin/users/${id}`),
  getLicences: () => client.get("/api/admin/licences"),
  revokeLicence: (key) => client.post(`/api/admin/licences/${key}/revoke`),
  deactivateMachine: (key, fingerprint) =>
    client.post(`/api/admin/licences/${key}/machines/deactivate`,
                null, { params: { fingerprint } }),
  getCoupons: () => client.get("/api/admin/coupons"),
  createCoupon: (data) => client.post("/api/admin/coupons", data),
  deleteCoupon: (id) => client.delete(`/api/admin/coupons/${id}`),
  getOrders: (params) => client.get("/api/admin/orders", { params }),
  listAffiliates: () => client.get("/api/admin/affiliates"),
  createAffiliate: (data) => client.post("/api/admin/affiliates", data),
  affiliateCommissions: (id) => client.get(`/api/admin/affiliates/${id}/commissions`),
  markAffiliatePaid: (id, currency) =>
    client.post(`/api/admin/affiliates/${id}/mark-paid`, null,
                { params: currency ? { currency } : {} }),
};
